import { valibotResolver } from '@hookform/resolvers/valibot';
import { custom, nonEmpty, object, pipe, string, trim } from 'valibot';

export const EDIT_LOCATION_FIELDS = {
  ASSET_NAME: 'asset_name',
  NEW_NAME: 'new_name',
};

const findCoincidence = (newName, currentLocation, locations) => {
  if (currentLocation === newName) {
    return true;
  }
  return !locations.find((location) => location.name === newName.trim());
};

export const schemaEditLocation = (currentLocation = '', locations) =>
  valibotResolver(
    object({
      [EDIT_LOCATION_FIELDS.ASSET_NAME]: pipe(string(), nonEmpty('This field is required.')),
      [EDIT_LOCATION_FIELDS.NEW_NAME]: pipe(
        string(),
        trim(),
        nonEmpty('This field is required.'),
        custom(
          (newName) => findCoincidence(newName, currentLocation, locations),
          'Location with this name already exists!',
        ),
      ),
    }),
  );

export const editLocationDefaultValue = (currentName, dataOneLocation) => ({
  [EDIT_LOCATION_FIELDS.ASSET_NAME]: dataOneLocation?.parent?.name || '',
  [EDIT_LOCATION_FIELDS.NEW_NAME]: currentName || '',
});
